// extracted by mini-css-extract-plugin
export default {"item":"IconListItem-module--item--44c3d","icon":"IconListItem-module--icon--6c6c3"};